import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-barchart",
  "use": "icon-barchart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-barchart\"><path d=\"M0 0h64v1024H0z\" p-id=\"5484\" /><path d=\"M0 960h1024v64H0zM192 320h128v512H192zM384 0h128v832H384zM576 192h128v640H576zM768 576h128v256h-128z\" p-id=\"5485\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol